import EmailValidation from '@/forms/FormElements/Rows/EmailRow/EmailRow.validation';
import NameValidation from '@/forms/FormElements/Rows/NameRow/NameRow.validation';
import BaseValidation from '@/forms/Validations/BaseValidation';

import { names } from './SecondStep.types';
import { required, requiredIf, email } from 'vuelidate/lib/validators';
import ApiService from '@/common/ApiService/ApiService';
import { HttpVerb } from '@/common/ApiService/HttpVerb';

const derService = new ApiService('/api/DerService/', {
  returnData: true,
});

export const isDuplicate = (value: string) => {
  const { Recipients: recipients, Email: userEmail } = model;

  if (recipients.length) {
    const emailList = recipients.map((recipient) => recipient.Email);
    if (userEmail) emailList.push(userEmail);
    const dubplicates = emailList.reduce(
      (agg, col) => {
        agg.filter[col] = agg.filter[col] ? agg.dup.push(col) : 2;
        return agg;
      },
      {
        filter: {},
        dup: [],
      },
    ).dup;

    return dubplicates.indexOf(value) === -1;
  }

  return true;
};

export const isInDerSubscription = async (value: string) => {
  const { ItineraryId, DepartureId } = model;

  //if (!value || !(email as any)(value)) return true;

  if (value && ItineraryId && DepartureId) {
    const param = {
      Email: value,
      ItineraryId,
      DepartureId,
    };

    const result = await derService.call(`CheckEmailNew`, param, {
      handleErrors: false,
      showLoading: false,
      cancel: false,
      verb: HttpVerb.POST,
    });
    return result;
  } else {
    return true;
  }
};

let model;

const destinValidation = new BaseValidation([
  {
    name: names.DestinationId,
    rules: { required },
    messages: {
      required: 'Choose a destination',
    },
  },
]);

const itinValidation = new BaseValidation([
  {
    name: names.ItineraryId,
    rules: { required },
    messages: {
      required: 'Choose an itinerary',
    },
  },
]);

const dateValidation = new BaseValidation([
  {
    name: names.Date,
    rules: { required },
    messages: {
      required: 'Choose a date',
    },
  },
]);

const isInDerSubsText =
  'This email address is already subscribed to receive Daily Expedition Reports from this voyage. (Reports may not begin arriving until a day or two after the expedition begins.)';
const emailValidation = new BaseValidation([
  {
    name: names.Email,
    rules: {
      required,
      email,
      isInDerSubscription: (value) => (isDuplicate(value) ? isInDerSubscription(value) : true),
      isDuplicate,
    },
    messages: {
      required: 'Enter an email',
      email: 'Enter a valid email address',
      isInDerSubscription: isInDerSubsText,
      isDuplicate: 'This email is already set for other recipient',
    },
  },
]);

const recipiValidation = new BaseValidation(
  [
    {
      name: names.Name,
      rules: {
        required,
      },
      messages: { required: 'Enter a name' },
    },
    {
      name: names.Email,
      rules: {
        required,
        email,
        isInDerSubscription: (value) => (isDuplicate(value) ? isInDerSubscription(value) : true),
        isDuplicate,
      },
      messages: {
        required: 'Enter an email',
        email: 'Enter a valid email address',
        isInDerSubscription: isInDerSubsText,
        isDuplicate: 'This email is already set for other recipient',
      },
    },
  ],
  `${names.Recipients}[]`,
);

export default () => {
  const validations = [
    NameValidation('Person', { removeTitle: true }),
    emailValidation,
    destinValidation,
    itinValidation,
    dateValidation,
    recipiValidation,
  ];
  model = BaseValidation.getModel(validations);

  return {
    validations: BaseValidation.getRules(validations),
    messages: BaseValidation.getMessages(validations),
    model,
  };
};
